import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from "@sentry/react";
import { default as posthog } from "posthog-js";
import { createContext, useContext } from "react";
import { isProd } from "./lib/mode.js";
// posthogToken is injected by the server (Netlify)
if (isProd && typeof window !== "undefined" && window.posthogToken) {
    posthog.init(window.posthogToken, {
        api_host: "https://eu.posthog.com",
        capture_pageview: false,
    });
}
if (isProd && process.env.SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        ignoreErrors: [
            "TypeError: Failed to fetch",
            "TypeError: NetworkError when attempting to fetch resource.",
            "TypeError: Cancelled",
            "TypeError: avbruten",
            "ResizeObserver loop limit exceeded",
            "ResizeObserver loop completed with undelivered notifications.",
        ],
        integrations: [
            Sentry.browserTracingIntegration(),
            posthog.sentryIntegration({
                organization: "sveriges-schackforbund",
                projectId: Number(process.env.SENTRY_DSN.split("/").pop()),
            }),
        ],
        tracesSampleRate: 1.0,
        environment: process.env.MODE,
        release: process.env.GITHUB_SHA,
        enabled: process.env.MODE !== "development",
    });
}
const TrackContext = createContext({
    page: () => { },
    identify: () => { },
    reset: () => { },
});
export const TrackProvider = (props) => {
    function page() {
        posthog.capture("$pageview");
    }
    function identify(id) {
        posthog.identify(id);
        Sentry.setUser({ id });
    }
    function reset() {
        posthog.reset();
        Sentry.setUser(null);
    }
    return (_jsx(TrackContext.Provider, { value: { identify, page, reset, posthog }, ...props }));
};
export const useTrack = () => useContext(TrackContext);
//# sourceMappingURL=TrackProvider.js.map